import { CopyBranding } from './Copy'

export const CopyPdl: CopyBranding = {
  PictogramsDescription: 'Pictogram dollies are available in all Iconic colours and styles as custom engraving by Kraus & Naimer, which can be arranged through your local wholesaler.',
  ProSeriesRangeDisplayName: 'PDL Pro',
}